module.exports = __webpack_public_path__ + "img/gift-rule_bg.596e3347.png";